module.exports = __webpack_public_path__ + "img/add-image.4ad69e98.svg";